import { XCircle } from "lucide-react";
import {
  Container,
  AnimationContainer,
  OuterGear,
  Content,
  InnerGear,
  CenterIcon,
  StatusText,
  Title,
  Subtitle,
  PulsingIcon,
} from "./style";
import Gear from "./components/gear";
import { useLocation } from "react-router-dom";

export default function PaymentProcessing() {
  const location = useLocation();
  const error = location.state?.error;

  return (
    <Container>
      <Content>
        <AnimationContainer>
          <OuterGear loading={false}>
            <Gear teeth={12} radius={80} color={"#f23236"} />
          </OuterGear>
          <InnerGear loading={false}>
            <Gear teeth={12} radius={60} color={"#f23236"} />
          </InnerGear>
          <CenterIcon loading={false}>
            <PulsingIcon>
              <XCircle size={64} color="#f23236" />
            </PulsingIcon>
          </CenterIcon>
        </AnimationContainer>
        <StatusText>
          <>
            <Title color="#f23236">Payment Failed 😔</Title>
            <Subtitle color="#f23236">
              Please try again or contact support
            </Subtitle>
            {error && (
              <div
                style={{
                  marginTop: "20px",
                  padding: "15px",
                  backgroundColor: "#fff5f5",
                  border: "1px solid #feb2b2",
                  borderRadius: "8px",
                  color: "#c53030",
                  fontSize: "13px",
                  textAlign: "left",
                  maxWidth: "400px",
                  margin: "20px auto 0 auto",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                <div
                  style={{
                    fontWeight: "bold",
                    marginBottom: "8px",
                    fontSize: "14px",
                  }}
                >
                  Debug Error Info:
                </div>
                <pre
                  style={{
                    margin: 0,
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-all",
                    fontFamily: "monospace",
                    lineHeight: "1.4",
                  }}
                >
                  {typeof error === "object"
                    ? JSON.stringify(error, null, 2)
                    : String(error)}
                </pre>
              </div>
            )}
          </>
        </StatusText>
      </Content>
    </Container>
  );
}
